import React, { useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ManageUserProfileFormPage } from '../../pages/ManageUser';
import { getUserMasterData, getNetworkStatus } from '../../../selectors/selector';
import { isUserValidated, getValidateUserDetails } from '../../../selectors/Manage/selector';
import { showNetworkAlert } from '../../../actions/App/action';
import {
  addUserDetails,
  validateUser,
  validateUserReset,
  transferUser
} from '../../../actions/manage/action';
import { handleSubmit, handleTransfer } from './ManageUserUtil';
import { Prompt } from 'react-router';

export const ManageUserProfileAddContainer: React.FC<any> = (props: any) => {

  const [submitNav, setSubmitNav] = useState<boolean>(true);

  return (
    <>
      <Prompt
          when={props.submitable && submitNav}
          message="Are you sure you want to navigate? Form data will get lost."
      />
      <ManageUserProfileFormPage
      {...props}
      selectedUser={null}
      addMode={props.addMode}
      handleSubmit={handleSubmit(props)}
      handleTransfer={handleTransfer(props)}
      setSubmitNavFlag={() => setSubmitNav(false)}
    />
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  userDetails: getUserMasterData(),
  isNetworkAvailable: getNetworkStatus(),
  isUserValid: isUserValidated(),
  validateUserDetails: getValidateUserDetails()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  validateUserAction: (payload: any) => dispatch(validateUser(payload)),
  addUserAction: (payload: any) => dispatch(addUserDetails(payload)),
  resetValidateUser: () => dispatch(validateUserReset()),
  transferUserAction: (payload: any) => dispatch(transferUser(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUserProfileAddContainer);
